import gettingStarted from './data/gettingStarted.json';
import ingredients from './data/ingredients.json';
import beerStyles from './data/beerStyles.json';
import advancedTechniques from './data/advancedTechniques.json';
import qualityControl from './data/qualityControl.json';
import troubleshooting from './data/troubleshooting.json';

// Combine all category data into a single array
export const libraryData = [
  gettingStarted,
  ingredients,
  beerStyles,
  advancedTechniques,
  qualityControl,
  troubleshooting
];
